import { Component } from '@angular/core';

@Component({
  selector: 'app-internal-error',
  standalone: true,
  imports: [],
  templateUrl: './internal-error.component.html',
  styleUrl: './internal-error.component.scss'
})
export class InternalErrorComponent {

}
